import React from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "../contexts/UserContext";
import ClipLoader from "react-spinners/ClipLoader";

const AccountShield = ({ allowedRoles, children }) => {
  const { user, loading } = useUser();

  if (loading) {
    return (
      <div
        className="d-flex flex-column justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <ClipLoader color="#5cd400" loading={true} size={50} />
        <div className="mt-3 text-muted fs-5">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return (
      <div
        className="d-flex flex-column justify-content-center align-items-center text-center"
        style={{ height: "100vh", padding: "20px" }}
      >
        <h2 className="text-danger">Access Denied</h2>
        <p className="text-muted fs-5">
          You are not authorized to view this page.
        </p>
      </div>
    );
  }

  return children;
};

export default AccountShield;
